// erf and NormSDist based on https://stackoverflow.com/a/73866203
function erf(x: number)
{
    //A&S formula 7.1.26
  
  let ans = 0;
  const a1 = 0.254829592;
  const a2 = -0.284496736;
  const a3 = 1.421413741;
  const a4 = -1.453152027;
  const a5 = 1.061405429;
  const p = 0.3275911;
  x = Math.abs(x);
  const t = 1 / (1 + p * x);
  //Horner's method, takes O(n) operations for nth order polynomial
  ans = 1 - ((((((a5 * t + a4) * t) + a3) * t + a2) * t) + a1) * t * Math.exp(-1 * x * x);
  return ans; 
}

export function NormSDist(z: number, cumulative: boolean)
{
    if (!cumulative) return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * z ** 2);
    let ans = 0;
    let sign = 1;
    if (z < 0) sign = -1;
    ans = 0.5 * (1.0 + sign * erf(Math.abs(z)/Math.sqrt(2)));
    return ans;
}

export function normalPDF(z: number) {
  return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * z ** 2);
}

// NormSInv based on https://stackoverflow.com/a/8843728
export function NormSInv(p: number): number {
    const a1 = -39.6968302866538, a2 = 220.946098424521, a3 = -275.928510446969;
    const a4 = 138.357751867269, a5 = -30.6647980661472, a6 = 2.50662827745924;
    const b1 = -54.4760987982241, b2 = 161.585836858041, b3 = -155.698979859887;
    const b4 = 66.8013118877197, b5 = -13.2806815528857;
    const c1 = -7.78489400243029E-03, c2 = -0.322396458041136, c3 = -2.40075827716184;
    const c4 = -2.54973253934373, c5 = 4.37466414146497, c6 = 2.93816398269878;
    const d1 = 7.78469570904146E-03, d2 = 0.32246712907004, d3 = 2.445134137143, d4 = 3.75440866190742;
    const p_low = 0.02425, p_high = 1 - p_low;
    let q, r;
    let retVal;

    if ((p < 0) || (p > 1))
    {
        alert("NormSInv: Argument out of range.");
        retVal = 0;
    }
    else if (p < p_low)
    {
        q = Math.sqrt(-2 * Math.log(p));
        retVal = (((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
    }
    else if (p <= p_high)
    {
        q = p - 0.5;
        r = q * q;
        retVal = (((((a1 * r + a2) * r + a3) * r + a4) * r + a5) * r + a6) * q / (((((b1 * r + b2) * r + b3) * r + b4) * r + b5) * r + 1);
    }
    else
    {
        q = Math.sqrt(-2 * Math.log(1 - p));
        retVal = -(((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
    }

    return retVal;
}